export type UpdatePasswordMode = 'resetPassword' | 'setPassword' | 'securityUpdate';
